import {Component, OnInit} from '@angular/core';

@Component({
    selector: 'app-rm-index',
    templateUrl: './rm-index.component.html',
    styleUrls: ['./rm-index.component.css', '../../../../assets/css/rm-theme.css'],
    standalone: false
})
export class RmIndexComponent implements OnInit {

    constructor(
    ) { }

    ngOnInit(): void {
        
    }
}
